import React from "react";
import {NOOP} from "../utils/NOOP";

export const HappinessCalculatorContext = React.createContext({
    planTimeRange: [],
    setPlanTimeRange: NOOP,
    planOccasionsCategories: [],
    setPlanOccasionsCategories: NOOP
});
